import { cacheTrends, getCachedTrends } from './indexedDB';

const AI_NEWS_SOURCES = [
  'https://techcrunch.com/tag/artificial-intelligence/feed/',
  'https://www.artificialintelligence-news.com/feed/',
  'https://www.axios.com/tags/artificial-intelligence/feed/',
  'https://feeds.feedburner.com/venturebeat/SZYF',
  'https://www.infoq.com/feed/ai-ml-data-eng/',
  'https://www.marktechpost.com/feed/',
  'https://blogs.nvidia.com/feed/',
  'https://machinelearningmastery.com/blog/feed/',
  'https://www.unite.ai/feed/',
  'https://www.analyticsvidhya.com/feed/'
];

const TESTING_NEWS_SOURCES = [
  'https://www.softwaretestingnews.com/feed/',
  'https://www.testingxperts.com/feed/',
  'https://www.perfecto.io/feed/',
  'https://www.ministryoftesting.com/feed/'
];

const INDUSTRY_NEWS_SOURCES = [
  'https://www.businesswire.com/portal/site/home/template.PAGE/news/technology/rss/',
  'https://www.prnewswire.com/rss/technology-latest-news.rss',
  'https://www.globenewswire.com/RssFeed/industry/9574-software/feedTitle/GlobeNewswire%20-%20Software'
];

const cleanHtml = (html) => {
  if (!html) return '';
  return html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .trim();
};

const isWithinLastWeek = (dateStr) => {
  const date = new Date(dateStr);
  const weekAgo = new Date();
  weekAgo.setDate(weekAgo.getDate() - 7);
  return date >= weekAgo;
};

const formatDate = (date) => {
  return new Date(date).toISOString().split('T')[0];
};

async function fetchRSSFeed(url) {
  try {
    const response = await fetch(`https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(url)}`);
    const data = await response.json();
    return data.items || [];
  } catch (error) {
    console.error(`Error fetching RSS feed from ${url}:`, error);
    return [];
  }
}

function filterAndFormatNews(news, count) {
  return news
    .filter(item => isWithinLastWeek(item.pubDate))
    .sort((a, b) => new Date(b.pubDate) - new Date(a.pubDate))
    .slice(0, count)
    .map(item => ({
      title: cleanHtml(item.title),
      link: item.link,
      pubDate: formatDate(item.pubDate),
      description: cleanHtml(item.description).substring(0, 200) + '...'
    }));
}

export async function fetchTrends(page = 1, limit = 5) {
  try {
    // Try to get cached data first
    const cached = await getCachedTrends();
    if (cached) {
      return {
        trends: cached,
        hasMore: false,
        page
      };
    }

    // Fetch fresh data with pagination
    const [aiNews, testingNews, industryNews] = await Promise.all([
      Promise.all(AI_NEWS_SOURCES.slice((page - 1) * limit, page * limit).map(url => fetchRSSFeed(url))),
      Promise.all(TESTING_NEWS_SOURCES.slice((page - 1) * limit, page * limit).map(url => fetchRSSFeed(url))),
      Promise.all(INDUSTRY_NEWS_SOURCES.slice((page - 1) * limit, page * limit).map(url => fetchRSSFeed(url)))
    ]);

    const trends = {
      aiTrends: filterAndFormatNews(aiNews.flat(), limit),
      testingTrends: filterAndFormatNews(testingNews.flat(), limit),
      industryTrends: filterAndFormatNews(industryNews.flat(), limit)
    };

    // Cache the results
    await cacheTrends(trends);

    return {
      trends,
      hasMore: page * limit < Math.max(
        AI_NEWS_SOURCES.length,
        TESTING_NEWS_SOURCES.length,
        INDUSTRY_NEWS_SOURCES.length
      ),
      page
    };
  } catch (error) {
    console.error('Error fetching trends:', error);
    throw error;
  }
}